import { createSlice } from "@reduxjs/toolkit";

const initialProjectState = {
  projects: [],
  currentProject: null,
  wireframes: [],
  sitemap: null,
  styleGuide: null,
  isLoading: false,
  generationStep: 'idle', // idle, generating-sitemap, generating-content, complete
  currentPage: 0,
  totalPages: 0,
  totalCount: 0,
  publishedCount: 0,
  error: null,
};

const projectSlice = createSlice({
  name: "project",
  initialState: initialProjectState,
  reducers: {
    resetState(state) {
      state.projects = [];
      state.currentProject = null;
      state.wireframes = [];
      state.sitemap = null;
      state.styleGuide = null;
      state.isLoading = false;
      state.generationStep = 'idle';
      state.currentPage = 0;
      state.totalPages = 0;
      state.totalCount = 0;
      state.publishedCount = 0;
      state.error = null;
    },
    setProjects(state, action) {
      state.projects = action.payload.projects;
      state.totalPages = action.payload.totalPages || 0;
      state.currentPage = action.payload.currentPage || 0;
      state.totalCount = action.payload.totalCount || 0;
      state.publishedCount = action.payload.publishedCount || 0;
    },
    setCurrentProject(state, action) {
      state.currentProject = action.payload;
      if (action.payload?.sitemap_json) {
        try {
          state.sitemap = JSON.parse(action.payload.sitemap_json);
        } catch (e) {
          state.sitemap = null;
        }
      }
      if (action.payload?.style_guide_json) {
        try {
          state.styleGuide = JSON.parse(action.payload.style_guide_json);
        } catch (e) {
          state.styleGuide = null;
        }
      }
    },
    setWireframes(state, action) {
      state.wireframes = action.payload;
    },
    updateWireframe(state, action) {
      const index = state.wireframes.findIndex(w => w.id === action.payload.id);
      if (index !== -1) {
        state.wireframes[index] = action.payload;
      }
    },
    removeWireframe(state, action) {
      state.wireframes = state.wireframes.filter(w => w.id !== action.payload);
    },
    setSitemap(state, action) {
      state.sitemap = action.payload;
      if (state.currentProject) {
        state.currentProject.sitemap_json = JSON.stringify(action.payload);
      }
    },
    setStyleGuide(state, action) {
      state.styleGuide = action.payload;
      if (state.currentProject) {
        state.currentProject.style_guide_json = JSON.stringify(action.payload);
      }
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setGenerationStep(state, action) {
      state.generationStep = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearProject(state) {
      state.currentProject = null;
      state.wireframes = [];
      state.sitemap = null;
      state.styleGuide = null;
      state.generationStep = 'idle';
      state.error = null;
    },
    addProject(state, action) {
      state.projects.unshift(action.payload);
    },
    removeProject(state, action) {
      state.projects = state.projects.filter(p => p.id !== action.payload);
      if (state.currentProject?.id === action.payload) {
        state.currentProject = null;
      }
    },
  },
});

export const projectActions = projectSlice.actions;
export default projectSlice.reducer;
